// extracted by mini-css-extract-plugin
export default {"cardHeader":"RJYZL88cEf98WngJHMd2","btnBox":"U4QsUu6uEBuDJDaio_c9"};